/* *************************************************************** *
 * THIS IS AN AUTO GENERATED FILE. PLEASE DO NOT EDIT IT DIRECTLY.
 *
 * If you want to change this Icon component , it is generated
 * from the `iconTamplate.js` file the parent directory.
 * *************************************************************** */
/* eslint-disable */
import React from 'react';
import { useFela, } from 'react-fela';
import iconStyle from '../iconStyle';
import { iconPropTypes, iconDefaultProps, } from '../iconPropTypes';

export default function IconError({ size, fill, color, attrs, miscStyles, ...props }) {
  const className = useFela({ size, fill, color, miscStyles, }).css(iconStyle);

  return (
    <svg width="1em" height="1em" viewBox="0 0 256 256" className={className} {...props} {...attrs} data-test="IconError">  <path fill="currentColor" d="M128 234c-58.449 0-106-47.552-106-106S69.551 22 128 22c58.448 0 106 47.552 106 106s-47.551 106-106 106zm0-197.986c-50.721 0-91.986 41.265-91.986 91.986S77.279 219.986 128 219.986c50.721 0 91.986-41.265 91.986-91.986S178.721 36.014 128 36.014z" />  <path fill="currentColor" d="M128 164.311c8.53 0 14.063 6.225 14.063 14.063 0 8.3-5.072 14.294-14.063 14.294-8.069 0-14.063-5.533-14.063-14.294 0-8.069 5.994-14.063 14.063-14.063zm-11.066-81.613V63.332h22.594v18.443c0 19.597-2.536 58.328-3.228 65.014h-16.369c-.461-6.455-2.997-44.726-2.997-64.091z" /></svg>
  );
}

IconError.propTypes = iconPropTypes;
IconError.defaultProps = iconDefaultProps;
